// <naviaq-data-grid></naviaq-data-grid>
(function () {
   'use strict';

   
    angular.module('NaviaqWebApp').directive('naviaqDataGrid', naviaqDataGrid);

    naviaqDataGrid.$inject = ['dxDataGridFactory'];

    function naviaqDataGrid(dxDataGridFactory) {
        return {
            restrict: 'E',
            scope: {
                gridOptions: '=',
                gridRef: '=',
                onGridInit: '&'
            },
            link: function(scope, element) {
                scope.gridRef = dxDataGridFactory.createGridInstance(element, scope.gridOptions);

                if (scope.onGridInit) {
                    scope.onGridInit({ grid: scope.gridRef });
                }
                
                scope.$on('$destroy', function() {
                    if (scope.gridInstance) {
                        scope.gridInstance.dispose();
                    }
                });
            }
        };
    }
})();